import { render, staticRenderFns } from "./SelectedPolygon.vue?vue&type=template&id=a8f85b74&"
import script from "./SelectedPolygon.vue?vue&type=script&lang=js&"
export * from "./SelectedPolygon.vue?vue&type=script&lang=js&"
import style0 from "./SelectedPolygon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VSelect,VTextField})
